import React, { PureComponent } from 'react'
import cx from 'classnames'
import moment from 'moment'
import SvgIcon from 'src/components/SvgIcon'

import styles from './NotificationBanner.module.less'

import {
  setNotificationCookieHidden,
  getNotificationCookieHidden,
  getKioskDocument,
} from 'src/utils/helpers'

class NotificationBanner extends PureComponent {
  state = {
    isMobileChatActive: false,
    isMapMobileActive: false,
  }

  calculateNotificationHeight() {
    const doc = getKioskDocument()
    const { setNotificationHeight, history } = this.props
    const notificationMinHeight = 76

    let elementHeight = notificationMinHeight
    //  detect resize for chat page
    this.setState({
      isMobileChatActive: history.location.pathname === '/chat' && doc.body.clientWidth <= 900,
      isMapMobileActive: history.location.pathname.includes('map') && doc.body.clientWidth <= 900,
    })
    // there are two banners one in AppLayout, another in Sidebar
    let elements = doc.querySelectorAll('.notification-banner')
    if (elements.length) {
      if (elements[0] && elements[0].offsetHeight) {
        elementHeight = elements[0].offsetHeight
      } else if (elements[1] && elements[1].offsetHeight) {
        elementHeight = elements[1].offsetHeight
      }
    }
    setNotificationHeight(elementHeight)
  }

  componentDidUpdate() {
    this.calculateNotificationHeight()
    this.detectNotificationStatus()
  }

  componentDidMount() {
    const { history } = this.props
    const doc = getKioskDocument()
    this.renderNotification()

    this.setState({
      isMobileChatActive: history.location.pathname === '/chat' && doc.body.clientWidth <= 900,
      isMapMobileActive: history.location.pathname.includes('map') && doc.body.clientWidth <= 900,
    })

    window.addEventListener('resize', this.calculateNotificationHeight.bind(this))
    this.unlisten = history.listen(() => {
      this.renderNotification()
    })
  }

  componentWillUnmount() {
    this.unlisten()
    window.removeEventListener('resize', this.calculateNotificationHeight.bind(this))
  }

  detectNotificationStatus() {
    const { areAppActionsDisabled, bannerNotification, setNotificationBannerHidden } = this.props
    if (
      bannerNotification &&
      bannerNotification.enableNotificationBanner &&
      !areAppActionsDisabled
    ) {
      const isSameDate =
        moment(bannerNotification.dateFrom).isSame(new Date(), 'day') ||
        moment(bannerNotification.dateTo).isSame(new Date(), 'day')
      if (getNotificationCookieHidden()) {
        setNotificationBannerHidden(true)
        return
      }
      if (
        (moment().isAfter(bannerNotification.dateFrom) &&
          moment().isBefore(bannerNotification.dateTo)) ||
        isSameDate
      ) {
        setNotificationBannerHidden(false)
      } else {
        setNotificationBannerHidden(true)
      }
    } else {
      setNotificationBannerHidden(true)
    }
  }

  renderNotification = () => {
    this.calculateNotificationHeight()
    this.detectNotificationStatus()
  }
  hideBanner = () => {
    const { setNotificationBannerHidden } = this.props
    setNotificationCookieHidden(true)
    setNotificationBannerHidden(true)
  }

  render() {
    const {
      className,
      isNotificationHidden,
      bannerNotification,
      areAppActionsDisabled,
    } = this.props
    const { isMobileChatActive, isMapMobileActive } = this.state

    const classNames = cx({
      'notification-banner': true,
      [className]: !!className,
      [styles.notificationBannerContainer]: true,
    })

    return !isNotificationHidden &&
      !areAppActionsDisabled &&
      !isMobileChatActive &&
      !isMapMobileActive ? (
      <div className={classNames}>
        <button className={styles.closeIconHolder} onClick={this.hideBanner}>
          <SvgIcon type='RemoveThinner' className={styles.closeIcon} />
        </button>
        <div className={styles.notificationIconHolder}>
          <SvgIcon type='Bell' className={styles.notificationIcon} />
        </div>
        <p
          className={styles.notificationMessage}
          dangerouslySetInnerHTML={{
            __html: bannerNotification.bannerMessage.replaceAll('<a', '<a target="_blank"'),
          }}
        ></p>
      </div>
    ) : null
  }
}

export default NotificationBanner
